import React, { useState } from 'react';
import './AdminBlock.css';

const AdminBlock = ({ title, children, defaultOpen = false, className = '', headerElement }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={`admin-block ${className}`}>
      <div 
        className={`admin-block-header ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <h3 className="admin-block-title">{title}</h3>
        <div className="admin-block-header-actions">
          {headerElement && (
            <div className="admin-block-header-custom" onClick={(e) => e.stopPropagation()}>
              {headerElement}
            </div>
          )}
          <span className={`admin-block-icon ${isOpen ? 'open' : ''}`}>▼</span>
        </div>
      </div>
      {isOpen && (
        <div className="admin-block-content">
          {children}
        </div>
      )}
    </div>
  );
};

export default AdminBlock;
